import { Layer } from '../classes';

export class MapnikMap {
  id: number;
  buffer_size: number;
  layers: Layer[];
  name: string;
  resource_uri: string;
  extent: string;
  layer_count: number;
  constructor(data?: object) {
    if (data) {
      this.setData(data);
    }
  }

  setData(options: object) {
    Object.assign(this, options);
  }
}
